<template>
    <div id='BuyTracker' class='row'>
        <div class='col-12'>
            <PaneHeader
                :product='subModuleTitle'
                :cardType='ItemCardType'
            />
            <ReceiptList v-if="this.activeSubModule == 'ReceiptListing'"/>
            <BoxList v-if="this.activeSubModule == 'BoxListing'"/>
            <ItemList v-if="this.activeSubModule == 'ItemListing'"/>
            <ItemCreateForm v-if="this.activeSubModule == 'ItemCreate'"/> 
            <ReceiptCreateForm v-if="this.activeSubModule == 'ReceiptCreate'"/>
            <BoxCreateForm v-if="this.activeSubModule == 'BoxCreate'"/>
        </div>
    </div>
</template>

<script>
    import ItemCreateForm from './ItemCreate/ItemCreateForm'
    import BoxList from './Lists/BoxList'
    import ReceiptList from './Lists/ReceiptList'
    import ItemList from './Lists/ItemList'
    import BoxCreateForm from './BoxCreate/BoxCreateForm'
    import ReceiptCreateForm from './ReceiptCreate/ReceiptCreateForm'
    import PaneHeader from '../../core/layout/PaneHeader'
    export default{
            name: 'BuyTracker',
            components: {
                ItemCreateForm,
                PaneHeader,
                BoxCreateForm,
                ReceiptCreateForm,
                ItemList,
                BoxList,
                ReceiptList
            },
            data() {
                return{
                    ItemCardType: 'ItemCard'
                }
            },
            computed: {
                pageForm(){
                    return this.$store.getters['BuyTracker/activePageType']
                },
                activeSubModule(){
                    return this.$route.name
                },
                subModuleTitle(){
                    return {
                        name: this.$route.meta.title
                    }
                },
                subcomponents(){
                    return this.$route.meta.subModules
                },
            },
            //created(){
              //  this.getModuleNavigation();
            //},
            methods:{
                getModuleNavigation(){
                    var nav = this.$store.getters['BuyTracker/pageType']
                    this.$store.commit('Navigation/setModuleNavs', nav)
                }
            },
            watch:{
                // what for some emit from subcompenents to change this comps data for navigation
            }
        }
</script>
